const DropdownIcon = (props: any) => {
    return (
        <img
            {...props}
            alt="dropdown_icon.png"
            src={require('./dropdown_icon.png')}
        />
    );
};

export default DropdownIcon;
